import React, { useState, useEffect, useCallback } from "react";

import { ChipDipCollectionProvider } from "../component/ChipDipCollection";

import HeaderTabs from "../layout/HeaderTabs";
import MainContent from "../layout/MainContent";

import ComponentRowsSearchModal from "../modals/ComponentRowsSearchModal";

import { useOrders } from "../hooks/useOrders";
import { useOffers } from "../hooks/useOffers";

import { fetchOffers } from "../api/offersApi";
import { fetchOrders } from "../api/ordersApi";
import { fetchReport } from "../api/reportsApi";
import styles from "../styles.module.css";

export default function MainLayout({ session }) {
    const { orders, setOrders } = useOrders();
    const { offers, setOffers } = useOffers();

    const [activeTab, setActiveTab] = useState(() => new URLSearchParams(window.location.search).get("tab") === "catalog-search" ? "catalog-search" : "new-analysis");
    const [showMyOrders, setShowMyOrders] = useState(false);
    const [showMyOffers, setShowMyOffers] = useState(false);

    const [showRowsSearchModal, setShowRowsSearchModal] = useState(false);

    const [reportData, setReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);
    const [reportLoaded, setReportLoaded] = useState(false);

    useEffect(() => {
        if (activeTab !== "analytics" || reportLoaded) return;

        setReportLoading(true);
        fetchReport()
            .then(data => {
                setReportData(data);
                setReportLoaded(true);
            })
            .finally(() => setReportLoading(false));
    }, [activeTab, reportLoaded]);

    useEffect(() => {
        if (activeTab !== "new-analysis") return;

        fetchOrders({ mine: showMyOrders })
            .then(setOrders)
            .catch(console.error);

        fetchOffers({ mine: showMyOffers })
            .then(setOffers)
            .catch(console.error);
    }, [activeTab, setOffers, setOrders, showMyOffers, showMyOrders]);

    const refreshChipDipResults = useCallback(async () => {
        const [nextOrders, nextOffers] = await Promise.all([
            fetchOrders({ mine: showMyOrders }), fetchOffers({ mine: showMyOffers })
        ]);
        setOrders(nextOrders);
        setOffers(nextOffers);
    }, [showMyOrders, showMyOffers, setOrders, setOffers]);

    return (
        <ChipDipCollectionProvider onCompleted={refreshChipDipResults}>
        <div className={styles.container}>
            <HeaderTabs
                session={session}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                onOpenRowsSearchModal={() => setShowRowsSearchModal(true)}
            />

            <MainContent
                session={session}
                showMyOrders={showMyOrders}
                showMyOffers={showMyOffers}
                onToggleMyOrders={() => setShowMyOrders(current => !current)}
                onToggleMyOffers={() => setShowMyOffers(current => !current)}
                activeTab={activeTab}
                orders={orders}
                offers={offers}
                reportData={reportData}
                reportLoading={reportLoading}
                setOffers={setOffers}
                setOrders={setOrders}
            />

            <ComponentRowsSearchModal
                isOpen={showRowsSearchModal}
                onClose={() => setShowRowsSearchModal(false)}
            />

        </div>
        </ChipDipCollectionProvider>
    );
}
